import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { GraphQLCommitmentParticipant } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { CalendarIcon } from '../../atoms/calendar-icon/calendar-icon.tsx';
import { ReminderAlert } from '../reminder-alert/reminder-alert.tsx';
export type ReminderAlertBirthdayProps = {
  ctaHref: string;
  participant: GraphQLCommitmentParticipant;
};
const getReminderGender = (gender?: string | null) => {
  if (gender === 'Male' || gender === 'Female') {
    return gender;
  }
  return 'Either';
};
export const ReminderAlertBirthday: React.FC<ReminderAlertBirthdayProps> = t0 => {
  const $ = _c(20);
  const {
    ctaHref,
    participant
  } = t0;
  const {
    t
  } = useTranslation("my");
  let t1;
  if ($[0] !== participant.gender) {
    t1 = getReminderGender(participant.gender);
    $[0] = participant.gender;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const gender = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("reminderAlert.give.cta");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ctaHref || $[5] !== t2) {
    t3 = {
      href: ctaHref,
      text: t2
    };
    $[4] = ctaHref;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== participant.birthdate) {
    t4 = participant.birthdate ? <CalendarIcon date={participant.birthdate} /> : null;
    $[7] = participant.birthdate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `reminderAlert.give.subtitle_${gender}`;
  let t6;
  if ($[9] !== t || $[10] !== t5) {
    t6 = t(t5);
    $[9] = t;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== participant.name || $[13] !== t) {
    t7 = t("reminderAlert.title", {
      name: participant.name
    });
    $[12] = participant.name;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t6 || $[18] !== t7) {
    t8 = <ReminderAlert cta={t3} icon={t4} subtitle={t6} title={t7} />;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};